import React from "react";
import styled from "styled-components";

const StyledIcon = styled("i")({
  display: "flex",
  alignItems: "center",
  width: "75px",
  height: "75px",
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  marginRight:"8px",
  backgroundImage:
    'url("/Site/images/icons/order-details/warning-colored.svg")',
  "@media (max-width: 768px)": {
    display: "none",
  },
});

const Container = styled("div")({
  width: "100%",
  display: "flex",
  gap: "8px",
  alignItems: "center",
  padding: "8px",
  borderRadius: "8px",
  backgroundColor: "#fff",
  color: "#1f1c43",
  fontSize: "14px",
  fontWeight: "400",
  justifyContent: "space-between",
  border: "1px solid #fcb041",
  fontFamily: `"pf_highway_sans_pro_lightRg", sans-serif`,
  backgroundColor: "#FFF",
  marginBottom: 24,
  "@media (max-width: 768px)": {
    flexWrap: "wrap",
    padding: "16px",
  },
});

const Content = styled("div")({
  display: "flex",
  gap: 4,
  alignItems: "center",
  "& > :first-child": {
    flexShrink: 0,
  },
  "@media (max-width: 768px)": {
    alignItems: "start",
    display: "block",
  },
});

const Title = styled("div")({
  fontWeight: 600,
  marginBottom: 8,
  fontSize: "16px",
  "@media (max-width: 768px)": {
    display: "flex",
    alignItems: "center",
    marginBottom: 16,
  },
});

const Description = styled("div")({
  paddingRight: 16,
  fontSize: "16px",
});

const Link = styled("a")({
  color: "#703EFF",
  fontWeight: 600,
  cursor: "pointer",
  fontSize: 14,
  textDecoration: "none",
  "&:hover": {
    color: "#502CB5",
  },
});

const MainContent = styled("div")({
  padding: "8px 0",
  "@media (max-width: 768px)": {
    padding: 0,
  },
})

const Img = styled("img")({
  "@media (max-width: 768px)": {
    margin: "0 auto",
  },
});

const SmallIcon = styled("img")({
  display: "none",
  "@media (max-width: 768px)": {
    display: "block",
    width: 45,
    height: 45,
    marginRight: 8,
  },
});

const WarningInfo = () => {
  const title = "Ticket Personalization";

  return (
    <Container>
      <Content>
        <StyledIcon />
        <MainContent>
          <Title>
            <SmallIcon src="/Site/images/icons/order-details/warning-colored.svg" />
             {orderdetails_resources.PersonalizationRequiredGov}
          </Title>
                  <Description
                  dangerouslySetInnerHTML={{ __html: orderdetails_resources.PersonalizationDescriptionGov }}/>
          <div style={{ marginTop: 16 }}>
             <Link href="https://tickets.gov.gr/" target="_blank">
             {orderdetails_resources.LearnMore}
            </Link>
          </div>
        </MainContent>
      </Content>
      <Img
        src="/Site/images/icons/order-details/govwalletinfo.png"
        alt="Wallet and QR code"
      />
    </Container>
  );
};

export default WarningInfo;
